import { LogOut } from 'lucide-react';

interface SignOutOverlayProps {
  open: boolean;
}

export function SignOutOverlay({ open }: SignOutOverlayProps) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-background/80 backdrop-blur-md animate-in fade-in duration-200">
      <div className="flex flex-col items-center justify-center space-y-4 p-8 rounded-3xl bg-card border border-border/50 shadow-2xl text-center max-w-xs mx-4 animate-in zoom-in-95 duration-300">
        <div className="relative flex items-center justify-center h-16 w-16">
          {/* Outer spinning gradient ring */}
          <div className="absolute inset-0 rounded-full border-4 border-primary/20 border-t-primary animate-spin" />
          {/* Inner pulsing container with LogOut icon */}
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-primary/10 text-primary animate-pulse">
            <LogOut className="h-5 w-5 text-primary" />
          </div>
        </div>
        <div className="space-y-1">
          <h3 className="font-semibold text-lg text-foreground">Saindo da conta...</h3>
          <p className="text-xs text-muted-foreground">Aguarde enquanto encerramos a sessão</p>
        </div>
      </div>
    </div>
  );
}

export default SignOutOverlay;
